import { createApp } from 'vue'
import App from './App.vue'
import setupPrimeVue from './primevue';
import router from './router'
import store from './store'; // Import the store
import '@/assets/tailwind.css';  // Import Tailwind CSS
import '@/assets/fonts/fonts.css';
import '@/assets/icons/icons.css';
import '@/assets/css/dark-theme.css'
import instantLinks from './config/instant_links.json'

const app = createApp(App).use(router).use(store)
setupPrimeVue(app);

app.provide('instantLinks', instantLinks);


app.mount('#app')
